import {Translator} from '@yandex-delivery/core/i18n'
import {noop} from '@yandex-delivery/utils'
import clsx from 'clsx'
import React, {useState, useSyncExternalStore} from 'react'
import {createPortal} from 'react-dom'

import {classes} from './classes'
import {NotificationsProvider} from './context'
import {Notification} from './Notification'
import {createNotificationStore, NotificationStore} from './store'
import {CustomNotification} from './types'

const emptyNotifications: readonly CustomNotification[] = []
const getServerSnapshot = () => emptyNotifications

// Порталы не могут быть гидратированы из HTML сервера. CSR может отобразить их сразу.
const subscribeToClient = () => noop
const getClientSnapshot = () => true
const getServerClientSnapshot = () => false

export const Notifications: React.FC<
  React.PropsWithChildren<{
    className?: string
    isNotificationsDisabled?: boolean
    i18n?: Translator
    store?: NotificationStore
  }>
> = ({children, className, isNotificationsDisabled, i18n, store}) => {
  // Провайдеры сохраняют независимые очереди, пока общий store не передан явно.
  const isClient = useSyncExternalStore(subscribeToClient, getClientSnapshot, getServerClientSnapshot)
  const [localStore] = useState(createNotificationStore)
  const activeStore = store ?? localStore
  const notifications = useSyncExternalStore(activeStore.subscribe, activeStore.getSnapshot, getServerSnapshot)

  return (
    <NotificationsProvider value={isNotificationsDisabled ? noop : activeStore.add}>
      {children}
      {isClient && typeof document !== 'undefined'
        ? createPortal(
            <ul className={clsx(classes.notificationsContainer, className)}>
              {notifications.map(item => (
                <Notification i18n={i18n} key={String(item.id)} remove={() => activeStore.remove(item.id)} {...item} />
              ))}
            </ul>,
            document.body,
          )
        : null}
    </NotificationsProvider>
  )
}
